import p1_img from "./product_1.png";
import p2_img from "./product_2.png";
import p3_img from "./product_3.png";
import p4_img from "./product_4.png";
import p5_img from "./product_5.png";
import p6_img from "./product_6.png";
import p7_img from "./product_7.png";
import p8_img from "./product_8.png";
import p9_img from "./product_9.png";
import p10_img from "./product_10.png";
import p11_img from "./product_11.png";
import p12_img from "./product_12.png";
import p13_img from "./product_37 (1).jpg";
import p14_img from "./product_38 (1).jpg";
import p15_img from "./product_39 (1).jpg";
import p16_img from "./product_40 (1).jpg";
import p17_img from "./product_41 (1).jpg";
import p18_img from "./product_42 (1).jpg";
import p19_img from "./product_43 (1).jpg";
import p20_img from "./product_44 (1).jpg";
import p61_img from "./product_53.jpg";
import p62_img from "./product_54.jpg";
import p63_img from "./product_55.jpg";
import p64_img from "./product_56.jpg";
import p65_img from "./product_57.jpg";
import p66_img from "./product_58.jpg";
import p67_img from "./product_59.jpg";
import p68_img from "./product_60.jpg";
import p69_img from "./product_4.png";
import p70_img from "./product_5.png";
import p71_img from "./product_6.png";
import p72_img from "./product_7.png";

import p21_img from "./product_13.png";
import p22_img from "./product_14.png";
import p23_img from "./product_15.png";
import p24_img from "./product_16.png";
import p25_img from "./product_17.png";
import p26_img from "./product_18.png";
import p27_img from "./product_19.png";
import p28_img from "./product_20.png";
import p29_img from "./product_21.png";
import p30_img from "./product_22.png";
import p31_img from "./product_23.png";
import p32_img from "./product_24.png";
import p33_img from "./product_45.jpg";
import p34_img from "./product_46.jpg";
import p35_img from "./product_47.jpg";
import p36_img from "./product_48.jpg";
import p37_img from "./product_49 (1).jpg";
import p38_img from "./product_52.jpg";
import p39_img from "./product_51 (1).jpg";
import p40_img from "./product_50 (1).jpg";
import p53_img from "./product_61.jpg";
import p54_img from "./product_62.jpg";
import p55_img from "./product_63.jpg";
import p56_img from "./product_64jpeg.jpg";
import p57_img from "./product_14.png";
import p58_img from "./product_15.png";
import p59_img from "./product_16.png";
import p60_img from "./product_17.png";
import p73_img from "./product_18.png";
import p74_img from "./product_19.png";
import p75_img from "./product_20.png";
import p76_img from "./product_21.png";

import p41_img from "./product_25.png";
import p42_img from "./product_26.png";
import p43_img from "./product_27.png";
import p44_img from "./product_28.png";
import p45_img from "./product_29.png";
import p46_img from "./product_30.png";
import p47_img from "./product_31.png";
import p48_img from "./product_32.png";
import p49_img from "./product_33.png";
import p50_img from "./product_34.png";
import p51_img from "./product_35.png";
import p52_img from "./product_36.png";

let all_product = [
  {
    id: 1,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 2,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p2_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 3,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p3_img,
    new_price: 60.0,
    old_price: 100.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 4,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p4_img,
    new_price: 100.0,
    old_price: 150.0,
    size: "S",
    Quantity: 1,
  },
  {
    id: 5,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p5_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 6,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p6_img,
    new_price: 75.0,
    old_price: 140.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 7,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p7_img,
    new_price: 95.0,
    old_price: 130.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 8,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p8_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 9,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p9_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 10,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p10_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 11,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p11_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 12,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 13,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p13_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 14,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p14_img,
    new_price: 95.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 15,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p15_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 16,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p16_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 17,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p17_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 18,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p18_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 19,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p19_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 20,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p20_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 61,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p61_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 62,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p62_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 63,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p63_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 64,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p64_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 65,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p65_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 66,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p66_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 67,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p67_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 68,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p68_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 69,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p69_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 70,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p70_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 71,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p71_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 72,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p72_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 21,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p21_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,

  },
  {
    id: 22,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p22_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
   
  },
  {
    id: 23,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p23_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 24,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p24_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 25,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p25_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 26,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p26_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 27,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p27_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 28,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p28_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 29,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p29_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 30,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p30_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 31,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p31_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 32,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p32_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },

  {
    id: 33,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p33_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 34,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p34_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 35,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p35_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 36,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p36_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 37,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p37_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 38,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p38_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 39,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p39_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 40,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p40_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 53,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p53_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 54,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p54_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 55,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p55_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 56,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p56_img,
    new_price: 850.0,
    old_price: 1200.5,
    size: "S",
    Quantity: 1,
  },
  
  {id: 57,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p57_img,
  new_price: 850.0,
  old_price: 1200.5,
  size: "S",
  Quantity: 1,
},
{id: 58,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p58_img,
  new_price: 850.0,
  old_price: 1200.5,
  size: "S",
    Quantity: 1,
},
{id: 59,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p59_img,
  new_price: 850.0,
  old_price: 1200.5,
 size: "S",
    Quantity: 1,
},
{id: 60,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p60_img,
  new_price: 850.0,
  old_price: 1200.5,
 size: "S",
    Quantity: 1,
},
{id: 73,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p73_img,
  new_price: 850.0,
  old_price: 1200.5,
 size: "S",
    Quantity: 1,
},
{id: 74,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p74_img,
  new_price: 850.0,
  old_price: 1200.5,
 size: "S",
    Quantity: 1,
},
{id: 75,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p75_img,
  new_price: 850.0,
  old_price: 1200.5,
 size: "S",
    Quantity: 1,
},
{id: 76,
  name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
  category: "men",
  image: p76_img,
  new_price: 850.0,
  old_price: 1200.5,
 size: "S",
    Quantity: 1,
},
  {
    id: 41,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p41_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 42,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p42_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 43,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p43_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 44,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p44_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 45,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p45_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 46,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p46_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 47,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p47_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 48,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p48_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 49,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p49_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 50,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p50_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 51,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p51_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  {
    id: 52,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p52_img,
    new_price: 85.0,
    old_price: 120.5,
    size: "S",
    Quantity: 1,
  },
  
];

export default all_product;
